import { render, staticRenderFns } from "./BroadcastContacts.vue?vue&type=template&id=01ce142a&"
import script from "./BroadcastContacts.vue?vue&type=script&lang=js&"
export * from "./BroadcastContacts.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports